export default "__VITE_ASSET__D1dy8i7J__"